import axiosService from '../axios'

export const create = (data: any) => {
  return axiosService({
    url: '/api.action/comment',
    method: 'post',
    data,
  })
}
